import { render, staticRenderFns } from "./normal-select.vue?vue&type=template&id=8cb0509e&scoped=true"
import script from "./normal-select.vue?vue&type=script&lang=js"
export * from "./normal-select.vue?vue&type=script&lang=js"
import style0 from "./normal-select.vue?vue&type=style&index=0&id=8cb0509e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb0509e",
  null
  
)

export default component.exports